import Keycloak from 'keycloak-js';
import {
    CLIENT_ID_POKER_STARS,
    OIDC_CLIENT_ID,
    OIDC_REALM,
    OIDC_URL,
    POKER_STARS_HOST
} from "../../../config/config";

const getClientId = (() => {
    if (window.location.host === POKER_STARS_HOST) {
        return CLIENT_ID_POKER_STARS;
    }

    return OIDC_CLIENT_ID;
})();

export const keycloakClient: Keycloak = new Keycloak({
    url: OIDC_URL,
    realm: OIDC_REALM,
    clientId: getClientId,
});

interface OidcClient {
    login(options?: any): Promise<void>;
    logout(options?: any): Promise<void>;
    register(options?: any): Promise<void>;
}

export interface OidcClientHookResult {
    client: OidcClient;
    authenticated: boolean;
    userDisplayName: string | undefined;
}
